/*@ngInject*/
const SectionTemplateEditorRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.getSectionTemplateById = function (sectionTemplateId) {
        var url = '/rest/SectionTemplate/' + sectionTemplateId;

        return this.get(url);
    };
};

angular.module('ums.configuration')
    .service('sectionTemplateEditorRepository', SectionTemplateEditorRepository);
